import { useTranslation } from 'react-i18next'
import { Markdown } from '@/shared/components/markdown/Markdown'
import { cn } from '@/shared/utils/cn'
import { RatingStars } from './RatingStars'
import {
  formatReleaseDate,
  stripLeadingTitle,
  type ReleaseNote,
} from './releases'

/**
 * Una nota de versión completa: producto, versión y fecha arriba, el cuerpo en
 * Markdown y las estrellas al pie. La pinta el histórico por cada nota y la
 * vista de UNA nota (`FeaturedReleaseNote`) con `destacada`, que solo le pone
 * el anillo: la nota se lee igual en los dos sitios.
 */
export function ReleaseNoteCard({
  note,
  myScore,
  destacada = false,
}: {
  note: ReleaseNote
  myScore: number | null
  destacada?: boolean
}) {
  const { t, i18n } = useTranslation()

  return (
    <article
      className={cn(
        'rounded-3xl border border-black/5 bg-white p-7 shadow-sm lg:p-9',
        destacada && 'ring-2 ring-primary/40',
      )}
    >
      <div className="mb-5 flex flex-wrap items-center gap-x-3 gap-y-2">
        <span className="rounded-full bg-primary/10 px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-primary">
          {note.product}
        </span>
        <span className="text-xs font-semibold text-muted-foreground">
          {t('releases.version', { version: note.version })}
        </span>
        <span className="text-xs text-muted-foreground">
          {formatReleaseDate(note.releasedAt, i18n.language)}
        </span>
      </div>

      <div className="mt-4">
        <Markdown>{stripLeadingTitle(note.body, note.version)}</Markdown>
      </div>

      <div className="mt-6 border-t border-black/5 pt-5">
        <RatingStars
          releaseNoteId={note.id}
          avgRating={note.avgRating}
          ratingsCount={note.ratingsCount}
          myScore={myScore}
        />
      </div>
    </article>
  )
}
